export const playType = [
  {
    "label": "自制剧",
    "value": "自制剧",
    "children": [
      {
        "label": "自制翻译剧",
        "value": "自制翻译剧",
        "children": [
          {
            "label": "配音剧",
            "value": "配音剧"
          },
          {
            "label": "无配音",
            "value": "无配音"
          },
        ]
      },
      {
        "label": "自制本土剧",
        "value": "自制本土剧"
      },
      {
        "label": "自制动态漫",
        "value": "自制动态漫"
      }
    ]
  },
  {
    "label": "外采剧",
    "value": "外采剧",
    "children": [
      {
        "label": "外采翻译剧",
        "value": "外采翻译剧",
        "children": [
          {
            "label": "首发",
            "value": "首发"
          },
          {
            "label": "二轮",
            "value": "二轮"
          }
        ]
      },
      {
        "label": "外采本土剧",
        "value": "外采本土剧",
        "children": [
          {
            "label": "首发",
            "value": "首发"
          },
          {
            "label": "二轮",
            "value": "二轮"
          }
        ]
      },
      {
        "label": "外采动态漫",
        "value": "外采动态漫",
        "children": [
          {
            "label": "首发",
            "value": "首发"
          },
          {
            "label": "二轮",
            "value": "二轮"
          }
        ]
      }
    ]
  }
]